export class Point {
  constructor(x, y, height, color) {
    this.x = x
    this.y = y
    this.vy = y
    this.restY = y

    this.height = height
    this.color = color
  }
}
